"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializePendo = initializePendo;
const lib_1 = require("../core/lib.js");
function isPendoAnalyticsEnabled() {
    // eslint-disable-next-line camelcase
    const { pendo_api_key } = window.sonar;
    // eslint-disable-next-line camelcase
    return Boolean(pendo_api_key) && (0, lib_1.isAnalyticsEnabled)();
}
function initializePendo(account, visitor) {
    var _a;
    if (((_a = window.pendo) === null || _a === void 0 ? void 0 : _a.initialize) && isPendoAnalyticsEnabled()) {
        const { initialize } = window.pendo;
        initialize({
            account,
            visitor
        });
    }
}
//# sourceMappingURL=lib.js.map